export default [
  'NF',
  'CF',
  'CTRC',
  'FAT',
  'MAN',
  'MEN',
  'NFE',
  'NFS',
  'REC',
  'BOL',
  'OFIC',
];



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-terceiro/tipos-documento.js